import { useTranslation } from "@/stores/RootStoreContext";
import { Markdown } from "@/text/Markdown";

export default function DCompanyFooter() {
  const { t } = useTranslation();
  return <Markdown value={t("dcompany.footer")} enableLinks />;
}
